<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h2>ארן</h2>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="חיפוש בארנים"
              single-line
              hide-details
              style="max-width: 300px; margin-right: 16px;"
            ></v-text-field>
                         <v-btn
               color="primary"
               @click="openCreateDialog"
               :loading="loading"
               style="margin-left: 8px;"
             >
               <v-icon left>add</v-icon>
               הוסף ארן חדש
             </v-btn>
             
             <v-btn
               color="secondary"
               @click="refreshData"
               :loading="loading"
               style="margin-left: 8px;"
             >
               <v-icon left>refresh</v-icon>
               רענן
             </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="arans"
              :loading="loading"
              :search="search"
              class="elevation-1"
              :rows-per-page-items="[10, 25, 50]"
              rows-per-page-text="שורות בעמוד:"
            >
              <!-- Name Column -->
              <template slot="items" slot-scope="props">
                <td>
                  <span
                    class="aran-name-link"
                    @click="goToEvents(props.item)"
                  >
                    {{ props.item.name }}
                  </span>
                </td>
                
                <!-- Description Column -->
                <td>
                  {{ props.item.description || 'אין תיאור' }}
                </td>

                                 <!-- Actions Column -->
                 <td>
                   <v-btn
                     icon
                     small
                     @click="deleteAran(props.item)"
                     color="error"
                   >
                     <v-icon>delete</v-icon>
                   </v-btn>
                 </td>
              </template>

              <!-- No Data -->
              <template slot="no-data">
                <v-alert :value="true" type="info">
                  לא נמצאו ארנים
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Create/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
                 <v-card-title>
           <span class="headline">הוסף ארן חדש</span>
         </v-card-title>
        <v-card-text>
                     <v-form ref="form">
            <v-text-field
              v-model="editedAran.name"
              label="שם הארן"
              :rules="[v => !!v || 'שם הארן הוא שדה חובה']"
              required
            ></v-text-field>
            
                         <v-textarea
               v-model="editedAran.description"
               label="תיאור"
               rows="3"
             ></v-textarea>
            

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click="closeDialog"
          >
            ביטול
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click="saveAran"
            :loading="saving"

          >
            שמור
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">מחיקת ארן</v-card-title>
        <v-card-text>
          האם אתה בטוח שברצונך למחוק את הארן "{{ aranToDelete.name }}"?
          פעולה זו לא ניתנת לביטול.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click="deleteDialog = false"
          >
            ביטול
          </v-btn>
          <v-btn
            color="red darken-1"
            flat
            @click="confirmDelete"
            :loading="deleting"
          >
            מחק
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { axiosInstance } from '@/api';

export default {
  name: 'Arans',
  data() {
    return {
      loading: false,
      saving: false,
      deleting: false,
      dialog: false,
      deleteDialog: false,

      search: '',
      arans: [],
             editedAran: {
         name: '',
         description: ''
       },
      aranToDelete: {},
      
      headers: [
        { text: 'שם הארן', value: 'name', sortable: true },
        { text: 'תיאור', value: 'description', sortable: false },
        { text: 'פעולות', value: 'actions', sortable: false }
      ],
      
    };
  },

  mounted() {
    this.fetchArans();
  },

  methods: {
         async fetchArans() {
       console.log('fetchArans called');
       this.loading = true;
       
       // Clear the array first to force Vue reactivity
       this.arans = [];
       
       try {
         // Using the correct aran API endpoint
         const response = await axiosInstance.get('/aran');
         console.log('API response:', response.data);
         
         // Transform aran data to include missing fields
         this.arans = (response.data.results || []).map(aran => ({
           _id: aran._id,
           name: aran.name,
           description: aran.description || 'אין תיאור',
           createdAt: aran.createdAt,
           updatedAt: aran.updatedAt
         }));
         
         console.log('Transformed arans:', this.arans);
       } catch (error) {
         console.error('Error fetching arans:', error);
         this.$store.dispatch('SHOW_SNACKBAR', { text: 'שגיאה בטעינת הארנים', color: 'error' });
         // Fallback to empty array
         this.arans = [];
       } finally {
         this.loading = false;
       }
     },

         openCreateDialog() {
       this.editedAran = {
         name: '',
         description: ''
       };
       this.dialog = true;
     },

    

         async saveAran() {
       if (!this.$refs.form.validate()) {
         return;
       }

       this.saving = true;
       try {
         // Using the correct aran API endpoint
         const response = await axiosInstance.post('/aran', {
           name: this.editedAran.name,
           description: this.editedAran.description
         });
         console.log('Aran created successfully:', response.data);
         
         this.$store.dispatch('SHOW_SNACKBAR', { text: 'הארן נוצר בהצלחה', color: 'success' });
           location.reload()
         this.closeDialog();
         
                   // Immediately refresh the data
          await this.fetchArans();
          console.log('Data refreshed, current arans:', this.arans);
          
          // Ensure DOM updates properly
          this.$nextTick(() => {
            console.log('DOM updated, table should be refreshed');
          });
         
       } catch (error) {
         console.error('Error saving aran:', error);
         this.$store.dispatch('SHOW_SNACKBAR', { text: 'שגיאה בשמירת הארן', color: 'error' });
       } finally {
         this.saving = false;
       }
     },

    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
    },

    deleteAran(aran) {
      this.aranToDelete = aran;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      this.deleting = true;
      try {
        // Using the correct aran API endpoint
                 await axiosInstance.delete(`/aran/${this.aranToDelete._id}`);
                  this.$store.dispatch('SHOW_SNACKBAR', { text: 'הארן נמחק בהצלחה', color: 'success' });
         this.deleteDialog = false;
         location.reload()
         // Immediately refresh the data
         await this.fetchArans();
         console.log('Data refreshed after delete, current arans:', this.arans);
         
         // Ensure DOM updates properly
         this.$nextTick(() => {
           console.log('DOM updated after delete, table should be refreshed');
         });
      } catch (error) {
        console.error('Error deleting aran:', error);
        this.$store.dispatch('SHOW_SNACKBAR', { text: 'שגיאה במחיקת הארן', color: 'error' });
      } finally {
        this.deleting = false;
      }
    },

         goToEvents(aran) {
       // Navigate to events page for this aran
       this.$router.push(`/events?aran=${aran._id}`);
     },
     
     refreshData() {
       console.log('Manual refresh requested');
       this.fetchArans();
     }
  }
};
</script>

<style scoped>
.v-data-table {
  direction: rtl;
}

.aran-name-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
}

.aran-name-link:hover {
  color: #1565c0;
  text-decoration: none;
}

.v-chip {
  cursor: pointer;
}

.v-chip:hover {
  opacity: 0.8;
}
</style> 


// WEBPACK FOOTER //
// src/views/Arans.vue